import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"

const ArticleRow = ({ node }) => {
  const content = node.content;
  if (!content) return null;
  var first_published_at;
  // parse published_at date and format as MM/DD/YYYY
  if (node.first_published_at) {
    const date = new Date(node.first_published_at);
    first_published_at = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
  }

  return (
  <a href={"/" + node.full_slug} className="flex flex-col sm:flex-row hover:bg-slate-50">
    <img className="w-auto sm:w-[200px] h-[160px] rounded object-cover m-4" alt={content.image?.alt} loading="lazy" src={`${content.image?.filename}/m/0x320`} />
    <div className="flex flex-col p-4">
      {first_published_at && <div className="text-xs my-2">{first_published_at} - Posted</div>}
      <div className="font-serif font-bold my-2">{content.title}</div>
      <div className="text-sm my-4 line-clamp-3">{content.excerpt}</div>
    </div>
  </a>
  )
};

const RelatedArticles = ({ blok }) => {
  // console.log(blok)
  return (
    <div className="py-5" {...storyblokEditable(blok)} style={{
      paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`,
    }}>
      <div className="container max-w-[700px] mx-auto py-10 text-center">
        <h2 className="text-3xl font-bold">{blok.title}</h2>
      </div>
      <div className="container max-w-screen-lg mx-auto flex flex-col divide-y">
        {
          blok.articles.map((a, i) => (
            <ArticleRow node={a} key={i} />
          ))
        }
      </div>
    </div>
  )
}

export default RelatedArticles
